export default {
  props: {
    account: {
      type: Object,
      required: true,
    },
    removable: {
      type: Boolean,
      default: true,
    },
    selectable: {
      type: Boolean,
      default: true,
    },
    showMessage: {
      type: Boolean,
      default: true,
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showStatusMessage() {
      return this.showMessage
        && typeof this.account.accountStatus !== 'undefined'
        && this.account.accountStatus !== 1;
    },
    classModifiers() {
      return {
        'bank-account': true,
        'bank-account--selectable': this.selectable,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/add-funds-bank-transfer/components/bank-account/bank-account.js